export const POPULAR_CALCULATORS = {
  title: 'Popular Calculators',
  list: [
    {
      id: 'interest_calculator_1',
      title: 'Interest Calculator',
      link: 'https://cleartax.in/s/simple-compound-interest-calculator',
    },
    {
      id: 'income_tax_calculator_2',
      title: 'Income Tax Calculator',
      link: 'https://cleartax.in/paytax/TaxCalculator',
    },
    {
      id: 'gratuity_calculator_3',
      title: 'Gratuity Calculator',
      link: 'https://cleartax.in/s/gratuity-calculator',
    },
    {
      id: 'sip_calculator_4',
      title: 'SIP Calculator',
      link: 'https://cleartax.in/s/sip-calculator',
    },
    {
      id: 'pf_calculator_5',
      title: 'PF Calculator',
      link: 'https://cleartax.in/s/pf-calculator',
    },
    {
      id: 'hra_calculator_6',
      title: 'HRA calculator',
      link: 'https://cleartax.in/paytax/HraCalculator',
    },
    {
      id: 'salary_calculator_7',
      title: 'Salary Calculator',
      link: 'https://cleartax.in/s/salary-calculator',
    },
    {
      id: 'ppf_calculator_8',
      title: 'PPF Calculator',
      link: 'https://cleartax.in/s/ppf-calculator',
    },
    {
      id: 'rd_calculator_9',
      title: 'RD Calculator',
      link: 'https://cleartax.in/s/rd-calculator',
    },
    {
      id: 'swp_calculator_10',
      title: 'SWP Calculator',
      link: 'https://cleartax.in/s/swp-calculator',
    },
    {
      id: 'compound_interest_calculator_11',
      title: 'Compound Interest Calculator',
      link: 'https://cleartax.in/s/compound-interest-calculator',
    },
    {
      id: 'mutual_fund_calculator_12',
      title: 'Mutual Fund Calculator',
      link: 'https://cleartax.in/s/mutual-fund-calculator',
    },
    {
      id: 'roi_calculator_13',
      title: 'ROI Calculator',
      link: 'https://cleartax.in/s/roi-return-on-investment-calculator',
    },
    {
      id: 'nps_calculator_14',
      title: 'NPS Calculator',
      link: 'https://cleartax.in/s/nps-calculator',
    },
    {
      id: 'discount_calculator_15',
      title: 'Discount Calculator',
      link: 'https://cleartax.in/s/discount-calculator',
    },
    {
      id: 'fd_calculator_16',
      title: 'FD Calculator',
      link: 'https://cleartax.in/s/fd-calculator',
    },
    {
      id: 'lumpsum_calculator_17',
      title: 'Lumpsum Calculator',
      link: 'https://cleartax.in/s/lumpsum-calculator',
    },
    {
      id: 'down_payment_calculator_18',
      title: 'Down Payment Calculator',
      link: 'https://cleartax.in/s/down-payment-calculator',
    },
    {
      id: 'retirement_planning_calculator_19',
      title: 'Retirement Planning Calculator',
      link: 'https://cleartax.in/s/retirement-planning-calculator',
    },
  ],
};

export const OTHER_CALCULATORS = {
  title: 'Other Calculators',
  list: [
    {
      id: 'car_loan_emi_calculator_1',
      title: 'Car Loan EMI Calculator',
      link: 'https://cleartax.in/s/car-loan-emi-calculator',
    },
    {
      id: 'emi_calculator_2',
      title: 'EMI Calculator',
      link: 'https://cleartax.in/s/emi-calculator',
    },
    {
      id: 'post_office_monthly_income_scheme_calculator_3',
      title: 'Post Office Monthly Income Scheme Calculator',
      link: 'https://cleartax.in/s/post-office-monthly-income-scheme-calculator',
    },
    {
      id: 'kisan_vikas_patra_calculator_4',
      title: 'Kisan Vikas Patra Calculator',
      link: 'https://cleartax.in/s/kvp-kisan-vikas-patra-calculator',
    },
    {
      id: 'payback_period_calculator_5',
      title: 'Payback Period Calculator',
      link: 'https://cleartax.in/s/payback-period-calculator',
    },
    {
      id: 'sukanaya_samriddhi_yojana_calculator_6',
      title: 'Sukanaya Samriddhi Yojana Calculator',
      link: 'https://cleartax.in/s/sukanya-samriddhi-yojana-ssy-calculator',
    },
    {
      id: 'scss_calculator_7',
      title: 'SCSS Calculator',
      link: 'https://cleartax.in/s/scss-calculator',
    },
    {
      id: 'present_value_calculator_8',
      title: 'Present Value Calculator',
      link: 'https://cleartax.in/s/present-value-calculator',
    },
    {
      id: 'cagr_calculator_9',
      title: 'CAGR Calculator',
      link: 'https://cleartax.in/s/cagr-calculator',
    },
    {
      id: 'future_value_calculator_10',
      title: 'Future Value Calculator',
      link: 'https://cleartax.in/s/future-value-calculator',
    },
    {
      id: 'tax_saving_calculator_11',
      title: 'Tax Saving Calculator',
      link: 'https://cleartax.in/s/tax-saving-calculator',
    },
    {
      id: 'depreciation_calculator_12',
      title: 'Depreciation Calculator',
      link: 'https://cleartax.in/s/depreciation-calculator',
    },
    {
      id: 'post_office_calculator_13',
      title: 'Post Office Calculator',
      link: 'https://cleartax.in/s/post-office-ppf-calculator',
    },
    {
      id: 'lease_calculator_14',
      title: 'Lease Calculator',
      link: 'https://cleartax.in/s/lease-calculator-india',
    },
    {
      id: 'sbi_sip_calculator_15',
      title: 'SBI SIP Calculator',
      link: 'https://cleartax.in/s/sbi-sip-calculator',
    },
    {
      id: 'crypto_tax_calculator_16',
      title: 'Crypto Tax Calculator',
      link: 'https://cleartax.in/s/crypto-tax-calculator',
    },
    {
      id: 'sbi_ppf_calculator_17',
      title: 'SBI PPF Calculator',
      link: 'https://cleartax.in/s/sbi-ppf-calculator',
    },
    {
      id: 'home_loan_emi_calculator_18',
      title: 'Home Loan EMI Calculator',
      link: 'https://cleartax.in/s/home-loan-emi-calculator',
    },
    {
      id: 'personal_loan_emi_calculator_19',
      title: 'Personal Loan EMI Calculator',
      link: 'https://cleartax.in/s/personal-loan-emi-calculator',
    },
    {
      id: 'elss_calculator_20',
      title: 'Elss Calculator',
      link: 'https://cleartax.in/s/elss-calculator',
    },
    {
      id: 'npv_calculator_21',
      title: 'NPV Calculator',
      link: 'https://cleartax.in/s/npv-calculator',
    },
    {
      id: 'mortgage_calculator_22',
      title: 'Mortgage Calculator',
      link: 'https://cleartax.in/s/mortgage-calculator',
    },
    {
      id: 'sbi_car_loan_emi_calculator_23',
      title: 'SBI Car Loan EMI Calculator',
      link: 'https://cleartax.in/s/sbi-car-loan-emi-calculator',
    },
  ],
};

export const DAYS_IN_YEAR = 365;
export const WEEKS_IN_YEAR = 52;
export const MONTHS_IN_YEAR = 12;
export const QUARTERS_IN_YEAR = 4;
